import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeWysiwygSection'
 * @name TypeWysiwygSectionFields
 * @type {TypeWysiwygSectionFields}
 * @memberof TypeWysiwygSection
 */
export interface TypeWysiwygSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized true
     */
    header?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'content' (Content)
     * @name Content
     * @localized true
     */
    content: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'backToTopCta' (Back to top CTA)
     * @name Back to top CTA
     * @localized false
     */
    backToTopCta?: EntryFieldTypes.Boolean;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'wysiwygSection' (WYSIWYG Section)
 * @name TypeWysiwygSectionSkeleton
 * @type {TypeWysiwygSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-26T16:42:32.444Z
 * @version 28
 */
export type TypeWysiwygSectionSkeleton = EntrySkeletonType<TypeWysiwygSectionFields, "wysiwygSection">;
/**
 * Entry type definition for content type 'wysiwygSection' (WYSIWYG Section)
 * @name TypeWysiwygSection
 * @type {TypeWysiwygSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-26T16:42:32.444Z
 * @version 28
 */
export type TypeWysiwygSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeWysiwygSectionSkeleton, Modifiers, Locales>;

export function isTypeWysiwygSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeWysiwygSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'wysiwygSection'
}
